import Form from 'antd/es/form';
import Input from 'antd/es/input';
import React from 'react';

import type { PipelineBlock, StringTemplateBlockConfig } from '@mai/types';

import { BooleanToggle } from './shared';

interface StringTemplateBlockEditorProps {
  block: PipelineBlock & { type: 'string_template' };
  onConfigChange: (config: StringTemplateBlockConfig) => void;
}

export const StringTemplateBlockEditor: React.FC<
  StringTemplateBlockEditorProps
> = ({ block, onConfigChange }) => {
  const [form] = Form.useForm();

  // Initialize form with current values
  React.useEffect(() => {
    form.setFieldsValue({
      template: block.config.template || '',
      strip_whitespace: block.config.strip_whitespace ?? true,
    });
  }, [block.config, form]);

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<StringTemplateBlockConfig>,
  ) => {
    onConfigChange({
      ...block.config,
      template: allValues.template || '',
      strip_whitespace: allValues.strip_whitespace ?? true,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      onValuesChange={handleValuesChange}
    >
      <Form.Item
        label="Template"
        name="template"
        rules={[{ required: true, message: 'Template is required' }]}
        help="Template string with variables like {{ variable_name }}"
      >
        <Input.TextArea
          rows={4}
          placeholder="Hello {{ name }}, your score is {{ score }}"
          style={{ fontFamily: 'monospace' }}
        />
      </Form.Item>

      <BooleanToggle
        label="Strip Whitespace"
        name="strip_whitespace"
        help="Remove leading and trailing whitespace from the result"
        checkedChildren="Yes"
        unCheckedChildren="No"
      />
    </Form>
  );
};
